import React, { Component } from 'react';
import dayjs from 'dayjs';

import { ProductList, VehicleList } from '@C/CreditCustomers/_utils/';
import services from '@C/CreditCustomers/_utils/data';
import { TableGrid } from '@C/TableGrid';
import { DateRangeFilter } from '@C/Utils';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { authService } from '@S';

import './styles.scoped.scss';
const col = [
  {
    name: 'Date',
    key: 'time_stamp',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Slip #',
    key: 'slip_no',
  },
  {
    name: 'Vehicle',
    key: 'vehicle.vehicle_no',
  },
  {
    name: 'Product',
    key: 'product',
    formatter(props) {
      return <>{props?.name || 'Cash Given'}</>;
    },
  },
  {
    name: 'Rate',
    key: 'product',
    formatter(props) {
      return <>{props?.price || '--'}</>;
    },
  },
  {
    name: 'Qty',
    key: 'quantity',
  },
  {
    name: 'Discount',
    key: 'discount',
  },
  {
    name: 'Amount (Excl Tax)',
    key: 'after_discount',
  },
  {
    name: 'Cash given',
    key: 'cash_given',
  },
  {
    name: 'Amount (Inc Tax)',
    key: 'after_tax',
  },
  {
    name: 'Cashier',
    key: 'cashier',
    formatter(props) {
      return (
        <>
          {props.first_name} {props.last_name}
        </>
      );
    },
  },
];

class CreditSale extends Component {
  constructor(props) {
    super(props);
    this.state = {
      creditSaleList: [],
      customer_id: authService.currentUserId,
      offset: 1,
      count: 0,
      limit: 20,
      start_date: this.props.cod
        ? this.props.date
        : dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: this.props.cod ? this.props.date : dayjs().format('YYYY-MM-DD'),
      product_id: '',
      vehicle_number: '',
      loading: true,
    };
    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getCreditCustomerSlips();
  }

  getCreditCustomerSlips = () => {
    services
      .getCreditCustomerSlips(this.state)
      .then((response) => {
        this.setState({
          creditSaleList: response.data.data.results,
          count: response.data.data.count,
          loading: false,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  handlePagination = (e) => {
    this.setState({ offset: e, loading: true }, function () {
      this.getCreditCustomerSlips();
    });
  };

  handleDateChange = (e) => {
    if (Array.isArray(e)) {
      const [start_date, end_date] = e;

      this.setState({
        start_date: start_date || '',
        end_date: end_date || '',
      });
      return;
    }

    const { name, value } = e.target;
    const { start_date, end_date } = this.state;

    let newStart = start_date;
    let newEnd = end_date;

    if (name === 'start_date') {
      newStart = value;
      const maxEnd = dayjs(value).add(6, 'month');

      // Adjust end date if it's before start or beyond 6 months
      if (dayjs(end_date).isBefore(value) || dayjs(end_date).isAfter(maxEnd)) {
        newEnd = maxEnd.format('YYYY-MM-DD');
      }
    } else if (name === 'end_date') {
      const maxEnd = dayjs(start_date).add(6, 'month');
      newEnd = value;

      // Adjust start or end date if invalid
      if (dayjs(value).isBefore(start_date)) {
        newStart = value;
      } else if (dayjs(value).isAfter(maxEnd)) {
        newEnd = maxEnd.format('YYYY-MM-DD');
      }
    }

    this.setState({
      start_date: newStart,
      end_date: newEnd,
    });
  };

  handleProductChange = (e) => {
    this.setState({ product_id: e?.value || '' });
  };

  handleVehicleChange = (e) => {
    this.setState({ vehicle_number: e?.value || '' });
  };

  handleQuickSearch = (e) => {
    e.preventDefault();
    if (
      this.limitInput.current.value === '' ||
      this.limitInput.current.value === '0'
    ) {
      return;
    }
    this.setState(
      { limit: this.limitInput.current.value, offset: 1 },
      function () {
        this.getCreditCustomerSlips();
      },
    );
  };

  resetFilter = () => {
    this.setState(
      {
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        product_id: '',
        vehicle_number: '',
        loading: true,
      },
      function () {
        this.getCreditCustomerSlips();
      },
    );
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, function () {
      this.getCreditCustomerSlips();
    });
  };

  render() {
    const { creditSaleList } = this.state;
    return (
      <>
        <section className="widget full-width list-table">
          <header>
            <h3> Credit sale list </h3>
          </header>
          <main>
            <div className="table-filters">
              <div className="filter-wrapper">
                <div className="filter-group">
                  <label>Date range:</label>
                  <DateRangeFilter
                    value={[this.state.start_date, this.state.end_date]}
                    onChange={this.handleDateChange}
                    limit={6}
                  />
                </div>
                <div className="filter-group">
                  <label>Product:</label>
                  <ProductList
                    onProductChange={this.handleProductChange}
                    value={this.state.product_id}
                    options={this.props.products}
                  />
                </div>
                <div className="filter-group">
                  <label> Vehicle:</label>
                  <VehicleList
                    handleDropdownChange={this.handleVehicleChange}
                    value={this.state.vehicle_number}
                    selectedCustomerId={this.state.customer_id}
                  />
                </div>

                <div className="filter-group with-icon">
                  <label>
                    Results to display- {this.state.limit || 20} (Total:{' '}
                    {this.state.count})
                  </label>
                  <form onSubmit={this.handleQuickSearch}>
                    <input type="text" name="limit" ref={this.limitInput} />
                    <button
                      type="submit"
                      className="search-icon"
                      onClick={this.handleQuickSearch}
                    />
                  </form>
                </div>
                <div className="filter-group reset-filter">
                  <button onClick={this.resetFilter}>Reset filters</button>
                </div>
                <div className="filter-group">
                  <button
                    className="submit"
                    type="submit"
                    onClick={this.submitForm}
                  >
                    Apply filter
                  </button>
                </div>
              </div>
            </div>
            <div className="table-wrapper">
              <div className="mini-summary">
                <ul>
                  <li>
                    <span>Total sale amount: </span>
                    <span>
                      {new Intl.NumberFormat('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                      }).format(
                        creditSaleList.reduce(
                          (a, b) => a + (b['after_tax'] || 0),
                          0,
                        ) || 0,
                      )}
                    </span>
                  </li>
                  <li>
                    <span>Total Quantity: </span>
                    <span>
                      {new Intl.NumberFormat('en-IN', {}).format(
                        creditSaleList.reduce(
                          (a, b) => a + (b['quantity'] || 0),
                          0,
                        ) || 0,
                      )}
                    </span>
                  </li>
                </ul>
              </div>
              {(() => {
                if (this.state.loading) {
                  return <DropLoaderLarge />;
                } else {
                  return (
                    <TableGrid
                      col={col}
                      row={creditSaleList}
                      offset={this.state.offset}
                      hideActions={true}
                      count={this.state.count}
                      limit={this.state.limit}
                      handlePagination={this.handlePagination}
                      invoice="credit"
                    />
                  );
                }
              })()}
            </div>
          </main>
        </section>
      </>
    );
  }
}

export { CreditSale };
